const constants = {
  siteName: 'マダムたぬきの夢占い',
  host: {
    local: 'localhost',
    development: 'develop--madam-tanuki.netlify.app',
    production: 'madam-tanuki.com',
  },
};
export default constants;
